import * as React from 'react';

export const LazyDurabilityQuestions = React.lazy(() => import('./component'));
